export default __webpack_public_path__ + "static/media/save.a73cc61e.svg";